export enum IssueDateType {
    Encounter = 1,
    Current  = 2,
}
